export const enum ChatMessageType {
  Chunk = 'chunk',
  TemplateChunk = 'template_chunk',
  ThoughtChunk = 'thought_chunk',
  User = 'user',
}

export interface TemplateFiles {
  edit: string;
  working: string;
  diff: string;
  display: string;
}

export interface BaseMessage {
  request_id: string;
  seq: number;
}

export interface TemplateChunkMessage extends BaseMessage {
  type: ChatMessageType.TemplateChunk;
  template_version: {
    created_at: string;
    html: string;
    template_version_id: string;
  };
  updated_html: string;
}

export interface UserChatMessage extends BaseMessage {
  type: ChatMessageType.User;
  data: string;
}

export interface ThoughtChunkMessage extends BaseMessage {
  type: ChatMessageType.ThoughtChunk;
  data: string;
}

export interface ChunkMessage extends BaseMessage {
  type: ChatMessageType.Chunk;
  data: string;
}

export interface ChatPayload {
  dossierId: string;
  templateId: string;
  status: string;
  message:
    | TemplateChunkMessage
    | UserChatMessage
    | ThoughtChunkMessage
    | ChunkMessage;
}

export interface ChatMessage {
  message_type: ChatMessageType;
  message: string;
  metadata?: {
    selected_text?: string;
    xpaths?: string[];
    reverted?: boolean;
    updated?: boolean;
  };
}

export interface ChatMessagesState {
  messages: ChatMessage[];
  buffer: {
    type: string;
    content: string;
  } | null;
}

export interface ChatContextType {
  chatMessages: ChatMessagesState;
  templateVersions: {
    [template_id: string]: {
      html: string;
      template_version_id: string;
      created_at: string;
    }[];
  };
  currentSelection: {
    selectedText: string | null;
    xpathIds: string[] | null;
  };
  chatHandler: {
    sendChat(data: {
      message: string;
      templateId: string;
      selectedText: string;
      xpaths: string[];
      threadId: string;
    }): void;
    clearChatMessages(): void;
  };
  chatThreads: {
    [templateId: string]: string;
  };
  setChatThread(templateId: string, threadId: string): void;
  clearChatThread(templateId: string): void;
  setCurrentSelection(data: {
    selectedText: string | null;
    xpathIds: string[] | null;
  }): void;
  clearSelection(): void;
}
